var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUoload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2949",
    x: 0.644531,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#1D2125"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 12.1348V15.1936C22.5 15.6078 22.665 16.0059 22.9593 16.2994C23.2544 16.5932 23.6539 16.758 24.0702 16.7579H27.579",
    stroke: "#426CFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.6602 17.0806V24.3687C27.6433 24.8454 27.5322 25.314 27.3334 25.7476C27.1345 26.1812 26.8518 26.5712 26.5016 26.895C26.1511 27.2203 25.7399 27.4734 25.2915 27.6398C24.8432 27.8062 24.3664 27.8826 23.8885 27.8647H17.4324C16.9515 27.8867 16.4711 27.8135 16.0186 27.6495C15.5661 27.4854 15.1505 27.2336 14.7954 26.9086C14.4418 26.5839 14.1562 26.1921 13.9553 25.7561C13.7544 25.3201 13.6421 24.8485 13.625 24.3687V15.6294C13.6419 15.1527 13.753 14.6841 13.9518 14.2505C14.1506 13.8169 14.4333 13.427 14.7835 13.1031C15.1341 12.7778 15.5452 12.5247 15.9936 12.3583C16.442 12.1919 16.9187 12.1155 17.3966 12.1334H22.257C22.999 12.1308 23.7152 12.4053 24.2653 12.9032L26.7832 15.2186C27.0518 15.45 27.2688 15.7354 27.4199 16.0562C27.571 16.377 27.6528 16.7261 27.6602 17.0806Z",
    stroke: "#426CFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.6445 18.7227V24.4847",
    stroke: "#426CFF",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.2801 21.1482L21.0132 18.8813C20.9642 18.8317 20.9058 18.7923 20.8414 18.7654C20.777 18.7385 20.7079 18.7246 20.6381 18.7246C20.5683 18.7246 20.4992 18.7385 20.4348 18.7654C20.3704 18.7923 20.312 18.8317 20.263 18.8813L17.9961 21.149",
    stroke: "#426CFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUoload);
export default __webpack_public_path__ + "static/media/uoload.c477d4d098078a6eaeb24b98fad14bc3.svg";
export { ForwardRef as ReactComponent };